
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'

import { haijiApi } from '@/api/haiji'
export default {
data() {
return {

security_code: '',
platformId: 5,
appId: 'wx497e1eae88ad98cb'
}
},
components: {
XInput,
XButton,
Group
},
created() {
this.getWxConfig()
this.goResult()
},
methods: {

getToken() {
this.$EpetJs.Common.baseApprove(this.appId, this.platformId, window.location.href,() => {
this.getWxConfig();
});
},

changeSecurityCode(val) {
this.security_code = val.toUpperCase();
},

getWxConfig() {
this.$EpetJs.Common.post("public/auth/conf",{
'apiList': ['scanQRCode','chooseImage','getLocalImgData','uploadImage','openLocation','getLocation'],
'platformId': this.platformId,
'currentUrl': window.location.href,
'debug': false
}).then(({ data }) => {
if (data.status_code==200) {
const conf=data.data.conf;
this.$wx.config(conf);
} else {
Vue.$vux.toast.text(data.message);
}
});
},

goResult() {
var security = this.$EpetJs.Helper.getUrlParam("security");
var s = this.$EpetJs.Helper.getUrlParam("s");

if (security && security != null) {
this.inquire(security);
return;
}

if(s && s!=null) {
this.inquire(s);
return;
}
},

toScan() {
var self = this;
this.$wx.scanQRCode({
needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
success: function(res) {
var result = res.resultStr; 
var security_code = self.$EpetJs.Helper.getUrlParam("security",result);
if(!security_code){
security_code = self.$EpetJs.Helper.getUrlParam("s",result);
}
self.inquire(security_code);
},
error:function(res){
self.$vux.toast.text('扫描出错了');
}
});
},

clickSearch() {
this.inquire(this.security_code)
},

inquire(codeValue) {
var self = this;
var changeCode = codeValue.replace(/\s/g, ""); 
this.$EpetJs.Common.ajax('get', `${haijiApi.outSecurityCodeUrl}/${changeCode}`).then(({ data }) => {
if (data.status_code == 200) {
sessionStorage.setItem('haijiInquireResult',JSON.stringify(data.data));
this.$router.push({name: "haiji_inquire_result",query: {security_code:changeCode}});
} else {
self.$vux.toast.text(data.message);
}
});
},
}
}
